import React from "react";
import { motion } from "framer-motion";
import { PlayBadge } from "./PlayBadge";
import { LANDING } from "@/constants/testIds";
import { LOGO_ICON_URL, APP_BADGES_IMAGE, PLAY_STORE_URL } from "@/lib/constants";

export const FinalCTA = () => {
  return (
    <section className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative overflow-hidden rounded-[2rem] bg-[#0A0A0A] text-white p-10 sm:p-16 lg:p-20"
        >
          {/* Ornaments */}
          <div className="absolute -top-32 -right-32 h-[500px] w-[500px] rounded-full bg-[#F25C2A]/30 blur-3xl" />
          <div className="absolute -bottom-32 -left-20 h-[300px] w-[300px] rounded-full bg-[#F25C2A]/20 blur-3xl" />

          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7">
              <div className="mb-7 inline-flex items-center gap-2.5 bg-white/10 backdrop-blur rounded-2xl px-4 py-2">
                <img src={LOGO_ICON_URL} alt="" className="h-7 w-7 object-contain" />
                <span className="font-serif text-xl tracking-tight">
                  EMD<span className="text-[#F25C2A]">pay</span>
                </span>
              </div>
              <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.02]">
                A marketplace for
                <br />
                <em className="italic text-[#F25C2A] font-normal">fees, travel &amp; cards</em>.
              </h2>
              <p className="mt-6 max-w-lg text-white/70 text-lg leading-relaxed">
                Download EMDpay to pay verified educators &amp; professionals,
                book flights, hotels and buses, and discover the right credit
                card — all in one app.
              </p>

              <div className="mt-9 flex flex-wrap items-center gap-3">
                <PlayBadge
                  testId={LANDING.finalCtaInstall}
                  variant="light"
                  className="bg-white text-[#0A0A0A] border-white hover:bg-white/90"
                />
                <a
                  href="mailto:support@emdpay.in"
                  className="inline-flex items-center gap-2 rounded-2xl border border-white/20 px-5 py-4 text-sm font-semibold hover:border-white/40 transition-all"
                >
                  Talk to our team
                </a>
              </div>
            </div>

            {/* App store badges image */}
            <div className="lg:col-span-5 flex justify-center lg:justify-end">
              <a
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="block"
                data-testid="landing-final-cta-badges"
              >
                <div className="relative bg-white rounded-3xl p-5 max-w-[260px]">
                  <img
                    src={APP_BADGES_IMAGE}
                    alt="Download EMDpay on Google Play and the App Store"
                    className="w-full h-auto object-contain"
                  />
                </div>
                <p className="mt-4 text-center text-xs uppercase tracking-[0.22em] font-semibold text-white/70">
                  Available on mobile
                </p>
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
